import { inject } from '@angular/core';
import { map, Observable, of } from 'rxjs';

import { HealthChecker, HealthIssueDetails } from '@ideals/services/health-checker';
import { NAVIGATOR } from '@ideals/types';

export class ConnectionChecker extends HealthChecker {
  readonly #navigator = inject(NAVIGATOR);

  getIssueDetails(): HealthIssueDetails {
    return {
      title: 'help_modal.TEXT.No_internet',
      description: 'help_modal.TEXT.Check_your_device',
    };
  }

  getReport(): { internet: 'online' | 'offline'; } {
    return { internet: this.#navigator.onLine ? 'online' : 'offline' };
  }

  hasIssue(): Observable<boolean> {
    return of(this.#navigator.onLine).pipe(
      map((online) => !online),
    );
  }
}
